import React from 'react'
import { PersianDate } from '../../../helpers/utility'

const styles = {
  table: {
    width: '100%',
    fontFamily: 'tahoma',
    borderCollapse: 'collapse'
  }
}

const Heading = ({ owner, event_date, event_end_date }) => {
  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <table style={styles.table}>
        <thead>
          <tr style={{ border: '1px solid #BBBBBB', background: 'orange' }}>
            <th colSpan="3" style={{ textAlign: 'center' }}>
              اطلاعات رویداد
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ border: '1px solid #BBBBBB', background: 'orange' }}>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              نام و نام خانوادگی
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              {' '}
              تاریخ برگزاری از
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}> الی</td>
          </tr>
          <tr style={{ border: '1px solid #BBBBBB' }}>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>{`${
              owner.first_name
              } ${owner.last_name}`}</td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              <PersianDate>{event_date}</PersianDate>
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              <PersianDate>{event_end_date}</PersianDate>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const Body = ({ address, password, username }) => {
  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <table style={styles.table}>
        <thead>
          <tr style={{ border: '1px solid #BBBBBB', background: 'lime' }}>
            <th colSpan="3" style={{ textAlign: 'center' }}>
              اطلاعات مورد نیاز برای شرکت در رویداد
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ border: '1px solid #BBBBBB', background: 'lime' }}>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              وب سایت برگزاری رویداد
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              نام کاربری
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              گذرواژه
            </td>
          </tr>
          <tr style={{ border: '1px solid #BBBBBB' }}>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              <a href={address} target="_blank">
                {address}
              </a>
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              {username}
            </td>
            <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
              {password}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const Descriptions = ({ description }) => {
  return (
    <table>
      <thead>
        <tr>
          <th style={{ textAlign: 'center' }}>
            اطلاعات مورد نیاز برای شرکت در رویداد
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            className="foreign-markup"
            dangerouslySetInnerHTML={{
              __html: description
            }}
          />
        </tr>
      </tbody>
    </table>
  )
}

const TicketOrderInfo = ({ host_data, username, userType }) => {
  let data ={}
  userType === "SCHOOL" ? data = host_data[username] : data=host_data
  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <table style={styles.table}>
        <thead>
          <tr style={{ border: '1px solid #BBBBBB', background: 'orange' }}>
            <th colSpan="3" style={{ textAlign: 'center' }}>
              اطلاعات کارت ورود به جلسه
            </th>
          </tr>
        </thead>
        <tbody>
          {
            Object.keys(data).sort().map(key => data[key]).map(data =>
              (
                <tr style={{ border: '1px solid #BBBBBB' }} key={data[0]}>
                  <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
                    {data[0] && data[0]}
                  </td>
                  <td style={{ border: '1px solid #BBBBBB', padding: 10 }}>
                    {data[1] && data[1]}
                  </td>
                </tr>
              )
            )
          }

        </tbody>
      </table>
    </div>
  )
}

const TicketOrder = ({
  title,
  event_date,
  event_end_date,
  host_data,
  address,
  order_code,
  ticket_orderOwners,
  cover,
  order_type,
  ticket_order_description,
  viewImage,
  event_type,
  userType
}) => (
    <div>
      {Object.keys(ticket_orderOwners).map((ownerId, i) => {
        const owner = ticket_orderOwners[ownerId]

        const password =
          order_type === 'single'
            ? order_code.substring(0, 8)
            : order_code.substring(0, 4) + owner.username.slice(-4)


        return (
          <div
            key={i}
            style={{
              fontFamily: 'tahoma',
              direction: 'rtl',
              border: '1px solid black',
              padding: '10px',
              marginBottom: 20,
              pageBreakAfter: 'always'
            }}
          >
            <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>
              رسید ثبت نام در {title}
            </h3>
            <br />
            <Heading
              owner={owner}
              event_date={event_date}
              event_end_date={event_end_date}
            />
            <br />
            {event_type === 'online' ? (
              <Body
                address={address}
                password={password}
                username={owner.username}
              />
            ) : (
                <div>
                  <h4>آدرس محل آزمون</h4>
                  <p>{address}</p>
                </div>
              )}
            <br />
            {viewImage &&
              cover && (
                <div>
                  <img
                    src={`http://api.mabna.aasoo.ir//${cover}`}
                    alt="cover"
                    style={{
                      width: '100%',
                      height: 'auto'
                    }}
                  />
                </div>
              )}
            <br />
            <Descriptions description={ticket_order_description} />
            {host_data &&
              <TicketOrderInfo
                host_data={host_data}
                username={owner.username}
                userType={userType}
              />
            }
          </div>
        )
      })}
    </div>
  )

export default TicketOrder





// WEBPACK FOOTER //
// ./src/components/common/events/TicketOrder.js